const SelectionBox = ({ boxStyles, selectedCount }) => {
  if (!boxStyles) return null;

  return (
    <div
      style={{
        position: "fixed",
        backgroundColor: "var(--color-accent-primary-soft)",
        border: "1px dashed var(--color-accent-primary)",
        zIndex: 3,
        pointerEvents: "none",
        ...boxStyles,
      }}
    >
      <div
        style={{
          fontSize: 16,
          padding: "4px 6px",
          backgroundColor: "var(--color-surface-inverse)",
          color: "var(--color-text-inverse)",
          borderRadius: 4,
          position: "absolute",
          top: -22,
          right: 0,
        }}
      >
        {selectedCount} selected
      </div>
    </div>
  );
};

export default SelectionBox;
